import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./common/print.css";
import { Button, Card, CardBody, CardHeader, Col } from "reactstrap";
import Swal from "sweetalert2";
import Axios from "axios";
import ReactToPrint from "react-to-print";
import { configuration } from "../appConfig";
import ReportHeader from "./common/ReportHeader";
import ReportFooter from "./common/ReportFooter";
import { calculatePrice } from "../pricing/calculatePrice";
import CustomerInfoTable from "./common/CustomerInfoTable";
import CarSVG from "../carbodyparts/CarSvg";
import CZPriceTable from "./common/CZPriceTable";
import ReportHeader_Swiss from "./common/ReportHeader_Swiss";
import ReportFooter_Swiss from "./common/ReportFooter_Swiss";
import ReportAuthorizationHandler from "./common/ReportAuthorizationHandler";
import SwissMiniReportAuthorization from "./common/SwissMiniReportAuthorization";
const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
});

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

export default class ReportMiniCZ extends Component {
    state = {
        selectedFile: "",
        order: {
            vinNumber: "",
            orderNumber: Math.round(Math.random() * 100000000),
            issuedOn: new Date(),
        },
        partDetails: null,
        twoDView: true,
        vinNumber: null,
        vinfolderList: [],
        showTwoDView: true,
        selectedPartInfo: [],
        scanresult: [],
        priceTotal: [],
        swissTable: [],
        words: {},
        jsonData: {},
        lang: "",
    };

    count = [];

    componentDidMount() {
        const selectedFile = localStorage.getItem("selectedFile");
        this.setState({ vinNumber: selectedFile });
        this.getData(selectedFile);
        this.vinFolderList();
        this.getLang()
    }

    getLang = () => {
        const base_url = window.location.origin;
        Axios.get(`${base_url}/lang.json`).then((res) => {
            let lang = localStorage.getItem("lang");
            this.setState({ lang: lang });
            this.setState({ words: res.data });
        });
    };

    lang = (word) => {
        const { lang, words } = this.state;
        return words[word] ? words[word][lang] : word;
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.lang !== prevState.lang) {
            return { lang: nextProps.lang };
        } else return null;
    }

    handleChange = (e) => {
        this.setState({
            customerInfo: {
                ...this.state.customerInfo,
                [e.target.name]: e.target.value,
            },
        });
    };

    customerInfo = async () => {
        //alert('No Partner Id selected! Please login.')
        const partnerId = localStorage.getItem("partnerId");
        const vin = localStorage.getItem("selectedFile");
        if (partnerId) {
            const res = await Axios.get(
                configuration.getCustomerInfo +
                "?partnerId=" +
                partnerId +
                "&vin=" +
                vin
            );
            if (res.data.length) {
                this.setState({ customerInfo: res.data[0] });
            }
        } else {
        }
    };

    vinFolderList = async () => {
        const partnerId = localStorage.getItem("partnerId");
        const selectedFile = localStorage.getItem("selectedFile");
        if (partnerId) {
            const response = await Axios.get(
                configuration.resultTxt +
                "?vin=" +
                selectedFile +
                "&partnerId=" +
                partnerId
            );
            if (response.data[0] && response.data[0].resultTXT) {
                this.setState({
                    vinfolderList: response.data,
                    scanresult: response.data[0].resultTXT,
                });
                response.data[0].resultTXT.scanresult && this.countDetails(response.data[0].resultTXT.scanresult);
            } else {
            }
        } else {
            this.props.history.push("/login");
        }
    };

    selectFile = (e) => {
        localStorage.setItem("selectedFile", e.target.value);
        this.setState({ selectedFile: e.target.value });
    };

    showDummyData = () => {
        this.customerInfo();
    };

    SizeDropdown = (size, index) => {
        const arr = [0, 10, 20, 30, 40, 50, 60, 70, 80];
        return (
            <select value={size} onChange={(e) => this.change(e.target.value, index)}>
                {arr.map((row, i) => (
                    <option key={i}>{row}</option>
                ))}
            </select>
        );
    };

    change = (val, index) => {
        //
        const { scanresult } =
            this.state.vinfolderList.length && this.state.vinfolderList[0].resultTXT;
        scanresult[index].size = val;
        this.setState({ scanresult });
        const result = window.confirm("Are you sure want to change Size?");
        if (result) {
            const url = configuration.Update_ResultTxt;
            let payload = {
                scanresult: scanresult,
                partnerId: localStorage.getItem("partnerId"),
                vin: localStorage.getItem("selectedFile"),
            };
            Axios.post(url, payload).then((res) => {
                Toast.fire({
                    type: "success",
                    title: "Data saved successfully",
                });
            });
        }
    };

    handleChange = (row, value, index) => {
        if (value > 0) {
            row.size = value;
            this.setState({ dd: row });
        }
    };

    changeCount = (row, value, index) => {
        if (value >= 0) {
            row.Amount = value;
            this.setState({ countRow: row });
        }
    };

    Update = () => {
        const url = configuration.Update_ResultTxt;
        let data = this.state.vinfolderList[0].resultTXT;
        data.partnerId = localStorage.getItem("partnerId");
        Axios.post(url, data).then((res) => {
            alert("data updated");
        });
    };

    calPrice = (average, count) => {
        let pp = calculatePrice(average, count);
        //this.count.push(pp)
        return (pp * 130) / 6;
    };

    calUnit = (average, count) => {
        let pp = calculatePrice(average, count);
        this.count.push(pp);
        return pp;
    };

    countDetails = async (rowArray) => {
        let promises = [];
        const partnerId = localStorage.getItem("partnerId");
        const vin = localStorage.getItem("selectedFile");
        for (let i = 0; i < rowArray.length; i++) {
            let url = configuration.GetPartDetails + "?vin=" + vin + "&partnerId=" +
                partnerId + "&part=" + rowArray[i].part; promises.push(Axios.get(url));
        } const arrRes = await Axios.all(promises);
        const ltgtdata = arrRes.map((result) => {
            let ltcount = 0;
            let gtcount = 0;
            let val = result.data && result.data.json.split("\r\n");
            return {
                part: result.data.part,
                count: val.length - 1,
                lt25: ltcount,
                gt25: gtcount,
                ltunit: calculatePrice(24, ltcount),
                gtunit: calculatePrice(26, gtcount),
            };
        });
        this.setState({ swissTable: ltgtdata });
    };
    backtoDashboard = () => {
        this.props.history.push("/dashboard")
        sessionStorage.setItem("isScrolled", false)
    }

    getData = async (selectedFile) => {
        Axios.get(
            `${configuration.getData}?vin=${selectedFile}&partnerId=${localStorage.getItem("partnerId")}`
        ).then((r) => {
            this.setState({
                Authorized: r.data.Authorized ? r.data.Authorized : false,
                id: r.data.Authorized ? r.data.DriveThrough == "1" ? "drive_in" : "drive_through" : "",
                jsonData: r.data,
                DATReportAuthorized: r.data.DATReportAuthorized,
                isDATReportAuthorizedKeyExists: r.data.hasOwnProperty("DATReportAuthorized"),
                TotalDentCount: r.data.TotalDentCount ? r.data.TotalDentCount : "0",
                ReportGenerated: r.data.ReportGenerated,
                name: r.data.AuthorizedName,
                ReportGeneratedStatus: r.data.hasOwnProperty('ReportGeneratedStatus') ? r.data.ReportGeneratedStatus : 'FAIL',
                customerCompany: r.data.CustomerCompany ? r.data.CustomerCompany : '',
            })
        }).catch(error => alert('An error occured please try again'));
    };

    changeAuthorizeFlag = (authorize, driveType) => {
        this.setState({
            jsonData: {
                ...this.state.jsonData,
                Authorized: authorize,
                DriveThrough:
                    driveType === "drive_through"
                        ? "0"
                        : driveType === "drive_in"
                            ? "1"
                            : "",
            },
        });
    };

    render() {

        const { orderNumber } = this.state.order;
        const scanResult =
            this.state.vinfolderList.length && this.state.vinfolderList[0];
        scanResult.resultTXT && scanResult.resultTXT.scanresult &&
            scanResult.resultTXT.scanresult.filter((row) => {
                if (row.size) {
                    let size = row.size - (row.size % 10);
                    return (row.size = row.size % 10 >= 5 ? size + 10 : size);
                } else {
                    return row;
                }
            });
        const userSession = localStorage.getItem("userSession");
        const data = userSession ? JSON.parse(userSession) : {};
        const { lang, jsonData } = this.state;
        return (
            <div className="animated fadeIn">
                <div xs="12" sm="12" className="p-2">
                    <Card className="print_button_card">
                        <CardHeader>
                            <div className="container-fluid">
                                <div className="row align-items-center p-0">
                                    <div className="col-lg-3 col-md-4 col-sm-12 col-12 mt-sm-10">
                                        <Button className="btn-danger mr-2" onClick={() => this.backtoDashboard()}>{this.lang("Back")}</Button>
                                        <small> <span>{this.lang("VIN Number")} :</span> {localStorage.getItem("selectedFile")}</small>
                                    </div>
                                    <div className="col-lg-9 col-md-8 col-sm-12 col-12 mt-sm-10 p-0">
                                        {/* <ReactToPrint trigger={() =>
                                            {
                                                document.title = localStorage.getItem("selectedFile");
                                                return (
                                                <button className="glass btn btn-lg btn-danger">
                                                <i className="fa fa-print" />
                                                &nbsp; {this.lang("Print PDF")}
                                                </button>
                                                );
                                                }}
                                                content={() => this.componentRef
                                            }
                                        /> */}
                                        <div className="d-flex align-items-center justify-content-end flex-wrap btn-position">
                                            {/* <ReportAuthorizationHandler
                                                jsonData={jsonData}
                                                lang={this.lang}
                                                reportType={"mini"}
                                                isRemoveDriveThroughButton={true}
                                                isAuthorized={jsonData.Authorized}
                                                changeAuthorizeFlag={(authorize, driveType) =>
                                                this.changeAuthorizeFlag(authorize, driveType)
                                                }
                                                selectedLanguage={lang}
                                            /> */}
                                            <SwissMiniReportAuthorization />
                                            <ReactToPrint
                                                trigger={() => {
                                                    document.title = document.title =
                                                        localStorage.getItem("selectedFile");
                                                    return (
                                                        <button className="btn btn-danger btn-lg pull-right">
                                                            <i className="fa fa-print" /> {this.lang("Print PDF")}
                                                        </button>
                                                    );
                                                }}
                                                content={() => this.componentRef}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CardHeader>
                    </Card>
                    {/* <Card>
                        <CardHeader>
                            <ReactToPrint trigger={() => {
                                document.title = localStorage.getItem("selectedFile");
                                return (
                                    <button className="glass btn btn-lg btn-danger pull-right">
                                        <i className="fa fa-print" />
                                        &nbsp; Print PDF
                                    </button>
                                );
                            }}
                                content={() => this.componentRef}
                            />
                            <Button className="btn-danger mr-2" onClick={()=>this.backtoDashboard()}>{this.lang("Back")}</Button>
                            <small> {this.lang("VIN Number")} : {localStorage.getItem("selectedFile")}</small>
                        </CardHeader>
                    </Card> */}
                    <div
                        className="container all-reports-top-wrapper"
                        id="divIdToPrint"
                        ref={(el) => (this.componentRef = el)}
                        style={{ padding: 0 }}
                    >
                        <div className="row row-zero page-break-row report-full-wrapper" data-content-name={this.lang("Page")}>
                            <div className="col-sm-12 full-height-col col-zero">
                                <Card>
                                    <CardBody className="col-zero">
                                        <div className="newFormatReport_wrapper">
                                            <ReportHeader_Swiss />
                                            {/* <div className="p-0 row "> */}
                                            <CustomerInfoTable />
                                            <CZPriceTable vinfolderList={this.state.vinfolderList.length && this.state.vinfolderList[0].resultTXT && this.state.vinfolderList[0].resultTXT.scanresult} />
                                            {/* </div> */}
                                        </div>
                                    </CardBody>
                                    <ReportFooter_Swiss />
                                </Card>
                            </div>
                        </div>
                        <div className="row row-zero page-break-row report-full-wrapper second-svg-section" data-content-name={this.lang("Page")}>
                            <div className="col-sm-12 full-height-col col-zero">
                                <Card>
                                    <CardBody className="col-zero">
                                        <div className="newFormatReport_wrapper">
                                            <ReportHeader_Swiss />
                                            <div className="container car-svg-main">
                                                <div className="row title-row-main">
                                                    <div className="col-sm-12 col-zero">
                                                        <h3 className="report-title">
                                                            {this.lang("2D")}<span> {this.lang("View")} </span>
                                                        </h3>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <CarSVG {...this.props} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </CardBody>
                                    <ReportFooter_Swiss />
                                </Card>
                            </div>
                        </div>
                    </div>
                    {/* <div>
                        <Card>
                            <CardBody>
                                <Link className="glass" to="/ReportFull">
                                    <button className="btn btn-danger btn-sm pull-right">
                                        <i className="fa fa-dot-circle-o"></i> {">>"}
                                    </button>
                                </Link>
                                <Link className="glass" to="/TabView">
                                    <button
                                        style={{ marginRight: 10 }}
                                        className="btn btn-danger btn-sm pull-right"
                                    >
                                        {"<<"} <i className="fa fa-dot-circle-o"></i>
                                    </button>
                                </Link>
                            </CardBody>
                        </Card>
                    </div> */}
                </div>
            </div>
        );
    }
}